import { AppService } from './../core/app.service';
import { Injectable } from "@angular/core";
import { AbstractService } from "../core/AbstractService";
import { CompteReq } from "../data/http/requests/compte.req";
import { CompteRes } from "../data/http/responses/compte.res";
import { HttpClient } from "@angular/common/http";
import { env } from "../../env/env";

@Injectable({
    providedIn: 'root'
})
export class CompteService extends AbstractService<CompteReq, CompteRes> {
    constructor(http: HttpClient, AppService: AppService) {
        super(`${env.apiUrl}compte`, http, AppService); 
    }
}